<template>
    <section>
        <header class="mt-6 mb-0">
            <h1 class="fs-32 m-0 regular">
                {{ $l10n.__('Configurez votre offre Sellsy') }}
                {{ $filters.capitalize($filters.lowerCase(currentPlanLabel)) }}
            </h1>
            <p class="mt-2 mb-0 semibold gray-60 fs-3" v-if="isSourceSale">
                <span>{{ $l10n.__("Date d'activation à partir du") }}</span>
                {{ $filters.dateFormatter(activationDate, 'SLASHED_DATE', false) }}
            </p>
        </header>
        <recurrency-toggle store="client"></recurrency-toggle>
        <article>
            <header class="flex-level mt-6 mb-5 pb-1">
                <h2 class="m-0">{{ $l10n.__('Ajouter des licences') }}</h2>
                <a
                    href="https://go.sellsy.com/tous-nos-modules"
                    target="_blank"
                    class="ml-3 fs-2 semibold link"
                    >{{ $l10n.__('Comparer les licences') }}</a
                >
            </header>
            <el-form-item prop="products" class="mb-2">
                <licence-product
                    class="mb-5"
                    v-for="product in availablesProducts"
                    :key="product.code"
                    :value="products[product.id]"
                    :product="product"
                    :plan="plan"
                    userType="client"
                    :numformat="numformat"
                    @input="updateProductQuantity"
                >
                </licence-product>
                <template #error="{ error }">
                    <div class="wp-10 mt-0 mb-5 alert alert-danger flex-level" style="order: -1">
                        <CompassIcon
                            type="alert"
                            size="medium"
                            icon="alert-circle-fill"
                            class="mr-1"
                        />
                        {{ error }}
                    </div>
                </template>
            </el-form-item>
        </article>

        <div class="separator gray-05-bkg"></div>
        <!-- Extras Modules -->
        <article>
            <el-form-item>
                <header>
                    <h2 class="mb-5 mt-6">{{ $l10n.__('Modules supplémentaires') }}</h2>
                </header>
                <bonus-pack
                    class="mb-5"
                    v-for="product in bonusPacksClient"
                    :key="product.code"
                    :value="products[product.id]"
                    :product="product"
                    :plan="plan"
                    userType="client"
                    :numformat="numformat"
                    :sourceLimitation="isSourceSale"
                    @input="updateProductQuantity"
                    @changePackPlan="switchPackPlan"
                >
                </bonus-pack>
            </el-form-item>
        </article>
    </section>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import RadioInput from 'vcomponents/inputs/RadioInput.vue';
import LicenceProduct from 'vcomponents/pages/account/LicenceProduct.vue';
import moment from 'moment';
import RecurrencyToggle from 'vcomponents/pages/account/client/RecurrencyToggle.vue';
import BonusPack from 'vcomponents/pages/account/BonusPack.vue';

const clientCart = createNamespacedHelpers('clientCart');
export default {
    computed: {
        ...clientCart.mapGetters([
            'expirationDate',
            'isSourceSale',
            'currentPlanLabel',
            'plans',
            'availablesProducts',
            'products',
            'plan',
            'periodApplianceStart',
            'numformat',
            'bonusPacksClient',
            'isSourceSale',
        ]),
        activationDate() {
            return _.isNil(this.periodApplianceStart)
                ? moment().format('YYYY-MM-DD HH:mm:ss')
                : this.periodApplianceStart;
        },
    },
    methods: {
        ...clientCart.mapActions(['updateProductQuantity', 'switchPackPlan']),
    },
    components: {
        RadioInput,
        LicenceProduct,
        RecurrencyToggle,
        BonusPack,
    },
};
</script>
